import claimService from '../services/claim.service';

const claims = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, claim) {
            return claimService.create(claim);
        },

        generateClaimBatch(_, claimId) {
            return claimService.generateClaimBatch(claimId);
        },
        addNote(_, params) {
            return claimService.addNote(params.claimId, params.text);
        },
        //READ
        get(_, params) {
            return claimService.get(params.id, params.urlParameters, params.requestId);
        },
        getClaimPreSubmissionFormDto(_, params) {
            return claimService.getClaimPreSubmissionFormDto(params.id, params.urlParameters, params.requestId);
        },        
        getreducedview(_, params) {
            return claimService.getreducedview(params.id, params.urlParameters, params.requestId);
        },
        getNonValidated(_, params) {
            return claimService.getNonValidated(params.id, params.urlParameters, params.requestId);
        },
        getageing(_, params) {
            return claimService.getAgeing(params.urlParameters);
        },
        getageingmanagement(_, params) {
            return claimService.getageingmanagement(params.urlParameters);
        },
        getPreSubmissionClaims() {
            return claimService.getPreSubmissionClaims();
        },
        getclaimsubmissionmanagementwidgetdto(_, params) {
            return claimService.getclaimsubmissionmanagementwidgetdto(params.urlParameters);
        },
        getclaimpostsubmissionformdto(_, params) {
            return claimService.getclaimpostsubmissionformdto(params.id, params.requestId, params.urlParameters);
        },
        getStatuses() {
            return claimService.getStatuses();
        },
        //UPDATE
        update(_, claim) {
            return claimService.update(claim);
        },

        setPrintedVerified(_, claim) {
            return claimService.setPrintedVerified(claim.id, claim.printedVerified);
        },

        updateClaimPostSubmissionDetails(_, params) {
            return claimService.updateClaimPostSubmissionDetails(params.id, params.formData);
        },
        claimlinknumberstatusimport(_, form) {
            return claimService.claimlinknumberstatusimport(form);
        },
        //DELETE
        delete(_, id) {
            return claimService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default claims;
